import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PreloaderServiceBase } from '@seahorse/common';
import { LoadingIndicatorComponent } from '@seahorse/ui';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'sh-seahorse-theme',
  templateUrl: './seahorse-theme.component.html',
  imports: [CommonModule, LoadingIndicatorComponent, RouterModule],
})
export class SeahorseThemeComponent implements OnInit, OnDestroy {
  toggleSidebar = false;

  status = {
    isLoading: true,
    preloaded: false,
  };

  get isAppReady() {
    return this.status.isLoading === false && this.status.preloaded === true;
  }

  subscriptions = new Subscription();
  layoutService = inject(LayoutService);
  private preloader = inject(PreloaderServiceBase);

  ngOnInit() {
    this.preloader.preload().subscribe(() => {
      this.status.isLoading = false;
      this.status.preloaded = true;
    });

    this.subscriptions.add(
      this.layoutService.sidebarToggle$.subscribe({
        next: (sidebarOpen) => {
          this.toggleSidebar = !!sidebarOpen;
        },
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
